import React from 'react';
import { AdditionalContentProps } from '../common/streamingServiceCommon/streamSvcPlaylistPlaylistRow';
import s from './soundCloud.module.scss';
import { SoundCloudPlaylistListItem } from './soundCloudPlaylistListItem';

/**
 * Artwork beside the title in the right-hand playlist list. SoundCloud
 * serves one size per URL suffix; `-large` is 100px, plenty for a 28px row,
 * and what `artwork_url` already names.
 */
export default function SoundCloudPlaylistRowContent({
  playlist,
}: AdditionalContentProps<SoundCloudPlaylistListItem>) {
  return (
    <>
      {playlist && playlist.artworkUrl && (
        <img className={s.playlistImg} src={playlist.artworkUrl} alt={playlist.title} />
      )}
    </>
  );
}
